<a (click)="logout()" pRipple class="flex items-center gap-4 cursor-pointer">
  <i class="pi pi-sign-out"></i>
  <span>Logout</span>
</a>
